import { Plugin } from '@ckeditor/ckeditor5-core';

/**
 * Generic mention-handling plugin.
 *
 * Configuration (editorConfig):
 *  mention: {
 *      items: [
 *          { keyword: 'soap', type: 'tag', payload: {...} },
 *          { keyword: 'exam', type: 'template', payload: {...} }
 *      ],
 *      handlers: {
 *          tag: 'insertTags',            // command name or function( editor, item )
 *          template: ( editor, item ) => { ... }
 *      }
 *  }
 */
export default class MentionActions extends Plugin {
    init() {
        const editor = this.editor;
        const mentionCmd = editor.commands.get( 'mention' );
        if ( !mentionCmd ) {
            return;
        }

        this.listenTo( mentionCmd, 'execute', ( evt, args ) => {
            const mentionData = args[ 0 ];
            const keywordId = mentionData?.mention?.payload?.id || '';

            const cfg = editor.config.get( 'mention' ) || {};
            const items = cfg.items || [];
            const item = items.find( i => i.payload?.id === keywordId );
            if ( !item ) {
                return;
            }

            // Prevent default insertion.
            evt.stop();

            editor.model.change( writer => {
                const typed = mentionData.marker + mentionData.text;
                const selection = editor.model.document.selection;
                const currentPos = selection.getFirstPosition();
                const startPos = currentPos.getShiftedBy( -typed.length );
                const range = writer.createRange( startPos, currentPos );
                writer.remove( range );
            } );

            const handlersMap = cfg.handlers || {};
            const handler = handlersMap[ item.type ];
            if ( !handler ) {
                return;
            }
            if ( typeof handler === 'string' ) {
                editor.execute( handler, { value: item.payload } );
            } else if ( typeof handler === 'function' ) {
                handler( editor, item );
            }
        }, { priority: 'high' } );
    }
}
